'use client'

import Script from 'next/script'
import { useContext } from 'react'
import { ConsentContext } from '@/context/ConsentContext'

declare global {
  interface Window {
    kameleoonQueue: Array<any>
  }
}

const Kameleoon = () => {
  const consentContext = useContext(ConsentContext)

  return (
    consentContext.consentReady &&
    consentContext.userConsents?.kameleoon && (
      <Script
        id="kameleoon-script"
        type="text/javascript"
        src="https://r4hs85umai.kameleoon.io/engine.js"
        onLoad={() => {
          console.log('[Kameleoon] Script loaded')
          window.kameleoonQueue = window.kameleoonQueue || []
        }}
        onError={(e) => console.error('[Kameleoon] Script load failed', e)}
      />
    )
  )
}

export default Kameleoon
